/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Kit 2 React components
import Container from "@mui/material/Container";
import MKBox from "components/MKBox";

import Grid from "@mui/material/Grid";
import Slider from "react-slick";
import MKTypography from "components/MKTypography";

// Images
import bathroom from "assets/images/projects/bathroom-renovation.jpeg";
import waterHeater from "assets/images/projects/water-heater.jpeg";
import leak from "assets/images/projects/leak.jpeg";
import sink from "assets/images/projects/sink.jpeg";
import proj5 from "assets/images/projects/40b42e1f-d9c9-492d-a33e-ae37631f9360.jpeg";
import proj6 from "assets/images/projects/783c3ad8-3211-471e-8777-4ab57a50a728.jpeg";
import proj7 from "assets/images/projects/1419aed2-3918-47e1-a86f-3d3eef61d209.jpeg";
import proj8 from "assets/images/projects/cb384d21-6d86-48e5-b040-973da3326fe4.jpeg";
import proj9 from "assets/images/projects/f77f9a09-a9be-4cb0-8188-8d6f7fe7ce09.jpeg";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Projects() {
  const services = [
    {
      // title: "Sink Faucet Installation",
      image: sink,
    },
    {
      // title: "Bathroom Renovation",
      image: bathroom,
    },
    {
      // title: "Water Heater Installation",
      image: waterHeater,
    },
    {
      // title: "Leak Detection",
      image: leak,
    },
    { image: proj5 },
    { image: proj6 },
    { image: proj7 },
    { image: proj8 },
    { image: proj9 },
  ];

  // const settings = {
  //   className: "slider variable-width",
  //   // dots: true,
  //   infinite: true,
  //   centerMode: true,
  //   slidesToShow: 3,
  //   slidesToScroll: 3,

  //   // swipeToSlide: true,
  //   variableWidth: true,
  //   autoplay: true,
  //   autoplaySpeed: 2000,
  //   adaptiveHeight: true,
  // };
  const settings = {
    className: "slider variable-width",
    infinite: true,
    centerMode: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    variableWidth: true,
    autoplay: true,
    autoplaySpeed: 2000,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1024, // tablets and smaller
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          variableWidth: false,
          centerMode: true,
        },
      },
      {
        breakpoint: 768, // phones
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false,
          centerMode: true,
        },
      },
      {
        breakpoint: 480, // smaller phones
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false,
          centerMode: false, // optional: center mode off for narrow screens
        },
      },
    ],
  };
  return (
    <MKBox component="section" py={6} mx={-2} bgColor="light">
      <Container>
        <Grid item md={6} sx={{ ml: 0, mb: { xs: 2, md: 5 } }}>
          <MKTypography variant="h2">OUR PROJECTS</MKTypography>
        </Grid>
        <Slider {...settings}>
          {services.map((proj, i) => (
            <div key={i} className="slider-container">
              <MKBox
                component="img"
                src={proj.image}
                alt={proj.title}
                sx={{
                  width: {
                    xs: "100%", // mobile (0px and up)
                    md: "300px", // desktop (900px and up)
                  },
                }}
              />
              {/* <p className="project-title">{proj.title}</p> */}
            </div>
          ))}
        </Slider>
      </Container>
    </MKBox>
  );
}

export default Projects;
